import { render, staticRenderFns } from "./DraftRelease.vue?vue&type=template&id=7a4f6f07&scoped=true&"
import script from "./DraftRelease.vue?vue&type=script&lang=js&"
export * from "./DraftRelease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4f6f07",
  null
  
)

export default component.exports